import React from 'react';
import { useTranslation } from "react-i18next";
import { db } from "../controllers/DB";
import { generateID } from "../controllers/misc";
import Api from "../api/api-wizard";

function Success() {

  const { t } = useTranslation();

  return (
    <div>
      <section class="position-relative">
        <div id="particles-js"></div>
        <div class="container">
          <div class="row  text-center">
            <div class="col">
              <img src="https://a-beta-crm.signuscorp.com/assets/img/logo-colored.png" style={{ marginBottom: "50px" }}
                height="50" />
              <h1>¡Ya falta poco!</h1>
              <img src="assets/images/success.png" style={{ height: "200px", width: "200px", marginTop: "40px" }} />
            </div>
          </div>
        </div>
      </section>

      <div class="page-content" style={{marginTop: "-100px"}}>
        <section class="text-center pb-11">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h3 class="mb-4">Hemos enviado un correo a tu cuenta, para continuar con el proceso.</h3>
                <a class="btn btn-primary" href="https://signuseducation.com/" target="_blanck">Visitar sitio web</a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div >
  );
}

export default Success;
